module.exports = __webpack_public_path__ + "img/close.76c0a478.svg";